/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloseOWActiveMatchBody
 */
export interface CloseOWActiveMatchBody {
    /**
     * Overwolf integer game id of the game that just exited.
     * @type {number}
     * @memberof CloseOWActiveMatchBody
     */
    gameId: number;
}

/**
 * Check if a given object implements the CloseOWActiveMatchBody interface.
 */
export function instanceOfCloseOWActiveMatchBody(value: object): value is CloseOWActiveMatchBody {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    return true;
}

export function CloseOWActiveMatchBodyFromJSON(json: any): CloseOWActiveMatchBody {
    return CloseOWActiveMatchBodyFromJSONTyped(json, false);
}

export function CloseOWActiveMatchBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseOWActiveMatchBody {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
    };
}

export function CloseOWActiveMatchBodyToJSON(json: any): CloseOWActiveMatchBody {
    return CloseOWActiveMatchBodyToJSONTyped(json, false);
}

export function CloseOWActiveMatchBodyToJSONTyped(value?: CloseOWActiveMatchBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
    };
}

